import { useState, useMemo, useEffect } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import { ArrowsFullscreen, XCircleFill } from "react-bootstrap-icons";

export default function AssetImageViewerUpload({ photoFiles, setPhotoFiles, type, isForm = true }) {
  const [index, setIndex] = useState(-1);

  const photos = useMemo(
    () =>
      photoFiles.map((file, idx) => ({
        src: URL.createObjectURL(file),
        width: 2,
        height: 1,
        key: idx,
      })),
    [photoFiles]
  );

  const handleDeletePhoto = (e, photoKey) => {
    let trueIdx = photoKey;
    const updatedPhotos = photoFiles.filter((_, idx) => idx !== trueIdx);
    setPhotoFiles(updatedPhotos, type, trueIdx); // Update parent state
    setIndex(-1);
  };

  const combinedPhoto = [...photos];

  useEffect(() => {
    return () => {
      photos.forEach((photo) => URL.revokeObjectURL(photo.src));
    };
  }, [photos]);

  return (
    <>
      <div className="row row-cols-5 pt-2 pb-4 border border-light rounded" style={{ backgroundColor: "#f2f0eb" }}>
        {combinedPhoto.map((photo, idx) => (
          <div key={photo.key} className="col position-relative mt-3" style={{ width: "25%", height: !isForm ? "140px" : "180px" }}>
            <img src={photo.src} alt={`Photo ${idx}`} style={{ width: "100%", height: "100%", objectFit: "cover" }} className="border border-2 rounded" />
            <div className="position-absolute top-0 end-0 mt-1 me-3 text-white rounded" style={{ padding: "0px 4px 3px 4px", cursor: "pointer" }} onClick={(event) => handleDeletePhoto(event, idx)}>
              <XCircleFill className="text-danger" width={18} height={18} />
            </div>
            <div className="position-absolute bottom-0 end-0 mb-1 me-3 rounded" style={{ padding: "0px 4px 3px 4px", cursor: "pointer" }} onClick={() => setIndex(idx)}>
              <ArrowsFullscreen className="text-dark" width={14} />
            </div>
          </div>
        ))}
      </div>
      {index >= 0 && <Lightbox index={index} slides={combinedPhoto.map((photo) => ({ src: photo.src }))} open={true} close={() => setIndex(-1)} />}
    </>
  );
}
